var _path, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOperatorIconLlm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 448a64 64 0 0 1 14.4 126.368l0.064 117.6a32 32 0 0 0 13.088 25.792l3.2 2.08 305.472 171.936a32 32 0 0 0 27.712 1.792l3.744-1.824 304-171.84a32 32 0 0 0 16-24.064l0.256-3.808V656a16 16 0 0 1 13.088-15.744l2.88-0.256a16 16 0 0 1 16 16v36.032a64 64 0 0 1-32.48 55.712l-304 171.84a64 64 0 0 1-62.88 0.096L175.04 747.744a64 64 0 0 1-32.64-55.776v-118.4A64 64 0 0 1 160 448zM543.424 104.896l304 171.84a64 64 0 0 1 32.512 55.712l-0.032 117.536a64 64 0 1 1-32.032 0.064l0.064-117.6a32 32 0 0 0-13.056-25.76l-3.2-2.08-304-171.84a32 32 0 0 0-27.68-1.856l-3.776 1.792-305.472 171.968a32 32 0 0 0-16.064 24.064l-0.224 3.808V368a16 16 0 0 1-31.776 2.88l-0.256-2.88v-35.456a64 64 0 0 1 32.64-55.776l305.472-171.936a64 64 0 0 1 62.88 0.064zM160 480a32 32 0 1 0 0 64 32 32 0 0 0 0-64z m704 0a32 32 0 1 0 0 64 32 32 0 0 0 0-64z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 630,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 245,
    fontWeight: 700,
    fill: "currentColor"
  }, "LLM")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatorIconLlm);
export default __webpack_public_path__ + "static/media/operator_icon_llm.a5114fcb2f7db3dc7fcac81b2055d40d.svg";
export { ForwardRef as ReactComponent };